import { render, staticRenderFns } from "./AuctionCurrency.vue?vue&type=template&id=1a9165d2&scoped=true"
import script from "./AuctionCurrency.vue?vue&type=script&lang=js"
export * from "./AuctionCurrency.vue?vue&type=script&lang=js"
import style0 from "./AuctionCurrency.vue?vue&type=style&index=0&id=1a9165d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9165d2",
  null
  
)

export default component.exports